import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthserviceService } from './authservice.service';
@Injectable({
  providedIn: 'root'
})
export class TokenGuardService  {

  constructor(public authService: AuthserviceService, public router: Router) { }
  canActivate(): boolean {
    if (!this.authService.getToken()) {
      return true;
    } else {
      this.router.navigateByUrl('/home');
        return false;
      }
    }
}
